// Shared between server (returned with the chat availability check) and
// web_client (rendered in the disabled chat button's tooltip). Keeping one
// definition stops the two surfaces from drifting into different copy.
export const PROVIDER_CHAT_UNAVAILABLE_MESSAGE =
  "You can't chat with this provider until they have been invited and created their account.";
